(() => {
  if (window.CaratKinSizeGuide) return;

  // "Chat with us" opens WhatsApp with a ring-size question. The number is the
  // store's, read from the floating WhatsApp button so there is one source.
  const launcher = document.querySelector(".ck-whatsapp__link");
  const whatsappNumber = (launcher && (launcher.getAttribute("href") || "").match(/wa\.me\/(\d+)/) || [])[1] || "919667316600";
  const helpUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Hey, I am not sure of my ring size. Can you please help me?")}`;

  const sizes = [
    [5, "44.80", "14.3", 3], [6, "46.10", "14.7", "3.5"], [7, "47.40", "15.1", 4],
    [8, "48.00", "15.3", "4.5"], [9, "48.70", "15.5", 5], [10, "50.00", "15.9", "5.5"],
    [11, "51.20", "16.3", 6], [12, "51.90", "16.5", "6.5"], [13, "53.10", "16.9", 7],
    [14, "54.40", "17.3", "7.5"], [15, "55.10", "17.5", 8], [16, "56.30", "18.0", "8.5"],
    [17, "57.00", "18.2", 9], [18, "58.30", "18.6", "9.5"], [19, "58.90", "18.8", 10],
    [20, "60.20", "19.2", "10.5"], [21, "60.80", "19.4", 11], [22, "62.10", "19.8", "11.5"],
    [23, "63.30", "20.2", 12], [24, "64.00", "20.4", "12.5"], [25, "65.20", "20.8", 13],
  ];

  const whatsappIcon = `<svg viewBox="0 0 17 17" aria-hidden="true"><path d="M12.858 3.314A6.64 6.64 0 0 0 8.126 1.35 6.695 6.695 0 0 0 2.328 11.38l-.945 3.47 3.544-.932a6.68 6.68 0 0 0 3.2.817 6.696 6.696 0 0 0 6.688-6.689 6.64 6.64 0 0 0-1.957-4.732Zm-4.732 10.287a5.55 5.55 0 0 1-2.835-.776l-.203-.122-2.105.554.56-2.052-.135-.21a5.54 5.54 0 0 1-.85-2.956 5.568 5.568 0 0 1 9.49-3.928 5.52 5.52 0 0 1 1.626 3.935c.014 3.064-2.484 5.555-5.548 5.555Zm3.05-4.158c-.168-.081-.991-.486-1.14-.547-.155-.054-.263-.081-.378.081-.114.169-.432.547-.526.655-.095.115-.196.128-.365.04-.169-.08-.709-.263-1.343-.83-.5-.446-.83-.992-.932-1.16-.094-.17-.013-.257.075-.345.074-.074.168-.196.25-.29.08-.095.114-.17.168-.277.054-.115.027-.21-.013-.29-.041-.082-.379-.905-.514-1.243-.135-.324-.276-.283-.378-.29h-.324c-.115 0-.29.04-.445.21-.149.168-.58.573-.58 1.397 0 .823.6 1.62.68 1.728.082.115 1.182 1.802 2.856 2.525.398.175.708.276.951.35.399.129.763.109 1.053.068.324-.047.992-.405 1.127-.796.141-.392.141-.723.094-.797-.047-.074-.148-.108-.317-.189Z" fill="currentColor"/></svg>`;

  function template() {
    const rows = sizes.map(([ind, circumference, diameter, us]) => `<tr><td>${ind}</td><td>${circumference}</td><td>${diameter}</td><td>${us}</td></tr>`).join("");
    return `
      <div class="size-guide-backdrop" data-size-guide-dialog aria-hidden="true">
        <aside class="size-guide-drawer" role="dialog" aria-modal="true" aria-labelledby="size-guide-title">
          <header class="size-guide-header"><h2 id="size-guide-title">Size Guide</h2><button class="size-guide-close" type="button" aria-label="Close size guide" data-size-guide-close><svg viewBox="0 0 44 44" aria-hidden="true"><path d="M28 16 16 28M16 16l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button></header>
          <div class="size-guide-scroll">
            <div class="size-guide-intro"><h3>Ring Size Guide</h3><p>Find your Carat &amp; Kin ring size using circumference or inner diameter.</p></div>
            <div class="size-guide-tabs" role="tablist" aria-label="Ring size information">
              <button type="button" role="tab" aria-selected="true" aria-controls="size-chart-panel" id="size-chart-tab" data-size-guide-tab="chart">Size Chart</button>
              <button type="button" role="tab" aria-selected="false" aria-controls="size-measure-panel" id="size-measure-tab" data-size-guide-tab="measure">How to Measure</button>
              <button type="button" role="tab" aria-selected="false" aria-controls="size-tips-panel" id="size-tips-tab" data-size-guide-tab="tips">Tips</button>
            </div>
            <section class="size-guide-panel" role="tabpanel" id="size-chart-panel" aria-labelledby="size-chart-tab" data-size-guide-panel="chart"><div class="size-guide-table-wrap"><table class="size-guide-table"><thead><tr><th>IND</th><th>Circ (mm)</th><th>Dia (mm)</th><th>US</th></tr></thead><tbody>${rows}</tbody></table></div></section>
            <section class="size-guide-panel" role="tabpanel" id="size-measure-panel" aria-labelledby="size-measure-tab" data-size-guide-panel="measure" hidden><div class="size-guide-steps">
              <article class="size-guide-step"><small>Step 1</small><h4>Measure with a string</h4><p>Wrap a string, paper strip, or fabric around the base of your finger. Keep it snug but comfortable, then mark where it overlaps.</p></article>
              <article class="size-guide-step"><small>Step 2</small><h4>Check the length</h4><p>Measure the marked length using a ruler and match it with the circumference column in the size chart.</p></article>
              <article class="size-guide-step"><small>Step 3</small><h4>Already have a ring?</h4><p>Place your ring on a ruler and measure the inner diameter. Match the diameter with the chart to find your size.</p></article>
            </div></section>
            <section class="size-guide-panel" role="tabpanel" id="size-tips-panel" aria-labelledby="size-tips-tab" data-size-guide-panel="tips" hidden><div class="size-guide-tips"><p>Before you choose</p>
              <article class="size-guide-tip"><h4>Measure in the evening</h4><p>Fingers are usually slightly larger in the evening, so this gives a more comfortable fit.</p></article>
              <article class="size-guide-tip"><h4>If it is a surprise</h4><p>When guessing a partner's ring size, choose slightly larger. It is easier to size down.</p></article>
              <article class="size-guide-tip"><h4>For thicker bands</h4><p>Bands wider than 6 mm may feel tighter. Consider going half a size up.</p></article>
              <article class="size-guide-tip"><h4>Average sizes</h4><p>Women commonly fall between Indian sizes 9–14, while men commonly fall between Indian sizes 17–22.</p></article>
            </div><p class="size-guide-note">Size guidance is approximate. For a perfect fit, we recommend speaking with a Carat &amp; Kin jewellery expert.</p></section>
          </div>
          <footer class="size-guide-help"><p>Need Help Choosing?</p><a href="${helpUrl}" target="_blank" rel="noopener">${whatsappIcon}<span>Chat with us</span></a></footer>
        </aside>
      </div>`;
  }

  document.body.insertAdjacentHTML("beforeend", template());
  const dialog = document.querySelector("[data-size-guide-dialog]");
  const drawer = dialog.querySelector(".size-guide-drawer");
  const closeButton = dialog.querySelector("[data-size-guide-close]");
  let returnFocus = null;

  function setTab(name, focus = false) {
    const tabs = [...dialog.querySelectorAll("[data-size-guide-tab]")];
    tabs.forEach((tab) => {
      const selected = tab.dataset.sizeGuideTab === name;
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });
    dialog.querySelectorAll("[data-size-guide-panel]").forEach((panel) => {
      panel.hidden = panel.dataset.sizeGuidePanel !== name;
    });
    dialog.querySelector(".size-guide-scroll").scrollTop = 0;
  }

  function open(trigger) {
    returnFocus = trigger || document.activeElement;
    dialog.classList.add("is-open");
    dialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("size-guide-is-open");
    setTab("chart");
    requestAnimationFrame(() => closeButton.focus());
  }

  function close() {
    dialog.classList.remove("is-open");
    dialog.setAttribute("aria-hidden", "true");
    document.body.classList.remove("size-guide-is-open");
    returnFocus?.focus?.();
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-size-guide], [data-size-guide-open]");
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }
    if (event.target.closest("[data-size-guide-close]") || (event.target === dialog && dialog.classList.contains("is-open"))) close();
    const tab = event.target.closest("[data-size-guide-tab]");
    if (tab) setTab(tab.dataset.sizeGuideTab);
  });

  dialog.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      close();
      return;
    }
    const current = event.target.closest("[data-size-guide-tab]");
    if (current && ["ArrowLeft", "ArrowRight"].includes(event.key)) {
      const tabs = [...dialog.querySelectorAll("[data-size-guide-tab]")];
      const offset = event.key === "ArrowRight" ? 1 : -1;
      const next = tabs[(tabs.indexOf(current) + offset + tabs.length) % tabs.length];
      setTab(next.dataset.sizeGuideTab, true);
    }
    if (event.key === "Tab" && dialog.classList.contains("is-open")) {
      const focusable = [...drawer.querySelectorAll("button:not([disabled]), a[href], [tabindex]:not([tabindex='-1'])")].filter((node) => !node.closest("[hidden]"));
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  window.CaratKinSizeGuide = { open, close, setTab };
})();
